import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import {
  useGetSkillGroupByProjectQuery,
  useGetTotalCompanyQuery,
  useGetTotalJobQuery,
} from "../../services/report.service";
import { BaseModal, GlassTable } from "../../components/global";

const ModalStatisticSkillByProject = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { data, isLoading, isFetching, isError } =
    useGetSkillGroupByProjectQuery(undefined, {
      skip: !open,
    });
  const { data: totalJob } = useGetTotalJobQuery(undefined, {
    skip: !open,
  });

  const sorted = React.useMemo(() => {
    const _data = data?.data;
    if (!_data || !totalJob) return [];
    const total = totalJob.total_completed + totalJob.total_created;
    const sorted = [..._data]
      .sort((a, b) => b.total - a.total)
      .map((it) => ({
        name: it.name,
        total: it.total,
        props: { percent: Number((it.total / total) * 100).toFixed(1) },
      }));
    return sorted || [];
  }, [data, totalJob]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (isError) {
    return (
      <BaseModal
        open={open}
        onClose={onClose}
        title="Number of Project With Skill"
        maxWidth="md"
        fullWidth
        useGlassCard={false}
      >
        <Box sx={{ textAlign: "center", py: 4 }}>
          <Typography color="error">Error loading data</Typography>
        </Box>
      </BaseModal>
    );
  }

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Number of Project With Skill"
      maxWidth="md"
      fullWidth
      useGlassCard={false}
    >
      {isLoading ? (
        <Box sx={{ textAlign: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      ) : sorted.length === 0 ? (
        <Box sx={{ textAlign: "center", py: 4 }}>
          <Typography color="text.secondary">No data available</Typography>
        </Box>
      ) : (
        <Box sx={{ p: { xs: 2, sm: 3 } }}>
          <GlassTable maxHeight={{ xs: 400, md: 500 }}>
            <Table size={isMobile ? "small" : "medium"}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.875rem", sm: "0.95rem" } }}>
                    Skill
                  </TableCell>
                  <TableCell 
                    align="right" 
                    sx={{ fontWeight: 600, fontSize: { xs: "0.875rem", sm: "0.95rem" } }}
                  >
                    Total - Percentage
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sorted.map((it, idx) => (
                  <TableRow key={idx} hover>
                    <TableCell sx={{ fontSize: { xs: "0.875rem", sm: "0.95rem" } }}>
                      <Typography component="span" sx={{ fontWeight: 500, color: "#12903C", mr: 1 }}>
                        {idx + 1}.
                      </Typography>
                      {it.name}
                    </TableCell>
                    <TableCell align="right" sx={{ fontSize: { xs: "0.875rem", sm: "0.95rem" } }}>
                      <Typography component="span" sx={{ fontWeight: 600, mr: 1 }}>
                        {it.total}
                      </Typography>
                      <Typography component="span" color="text.secondary">
                        - {it.props.percent}%
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </GlassTable>
        </Box>
      )}
    </BaseModal>
  );
};
export default ModalStatisticSkillByProject;
